"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderPlayerCount = void 0;
const getOrderLinePlayers_1 = require("./getOrderLinePlayers");
const getOrderPlayerCount = (order) => {
    if (!order)
        return " - ";
    if (!order.order_lines || order.order_lines.length === 0)
        return " - ";
    return (0, getOrderLinePlayers_1.getOrderLinePlayers)(order.order_lines[0]);
};
exports.getOrderPlayerCount = getOrderPlayerCount;
